import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";

// The API
import {
    TrainingWhiteList,
} from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "name",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "TRAINING_WHITE_LIST_LOADING" });
    },

    /**
     * Fetches the Training White List List
     * @param {Function} dispatch
     * @param {String=}  type
     * @param {Number=}  elemID
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, type = "", elemID = 0, params = {}) {
        Navigate.unsetParams(params);
        if (type === "ACTIVITY") {
            params.activityID = elemID;
        }

        const data = await TrainingWhiteList.getAll(params);
        data.sort  = params;
        dispatch({ type : "TRAINING_WHITE_LIST_LIST", data });
    },

    /**
     * Fetches a single Training WhiteList
     * @param {Function} dispatch
     * @param {Number}   trainingWhiteListID
     * @returns {Promise}
     */
    async fetchElem(dispatch, trainingWhiteListID) {
        const data = await TrainingWhiteList.getOne({ trainingWhiteListID });
        dispatch({ type : "TRAINING_WHITE_LIST_ELEM", data });
    },

    /**
     * Fetches the Training WhiteList Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await TrainingWhiteList.getEditData();
        dispatch({ type : "TRAINING_WHITE_LIST_EDIT", data });
    },

    /**
     * Edits/Creates a Training WhiteList
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return TrainingWhiteList.edit(data);
    },

    /**
     * Deletes a Training WhiteList
     * @param {Function} dispatch
     * @param {Number}   trainingWhiteListID
     * @returns {Promise}
     */
    deleteElem(dispatch, trainingWhiteListID) {
        return TrainingWhiteList.delete({ trainingWhiteListID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.isPastText = Utils.toYesNo(elem.isPast);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "TRAINING_WHITE_LIST_LIST", "TRAINING_WHITE_LIST_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "TRAINING_WHITE_LIST_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "TRAINING_WHITE_LIST_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "TRAINING_WHITE_LIST_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
            statuses  : action.data.statuses,
        };

    case "TRAINING_WHITE_LIST_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
